<template>
  <template
    v-for="(action, index) in actions"
    :key="index"
  >
    <template v-if="action.buttonType !== 'icon'">
      <BasicButton
        :label="action.label"
        size="small"
        @click="print(action)"
        :icon-name="action.iconName || 'print'"
        iconRight
        class="fixed-footer__imprimer fixed-footer__imprimer--desktop mobile-none"
      />
      <BasicTooltip
        :label="action.label"
        class="tablet-none desktop-none"
      >
        <BasicButton
          size="small"
          @click="print(action)"
          :icon-name="action.iconName || 'print'"
          class="fixed-footer__imprimer"
        />
      </BasicTooltip>
    </template>
    <BasicTooltip
      v-else
      :label="action.label"
    >
      <BasicButton
        @click="print(action)"
        size="small"
        :icon-name="action.iconName || 'print'"
        variant="outlined"
      />
    </BasicTooltip>
  </template>
</template>

<script setup lang="ts">
  import { inject } from 'vue'
  import { DEMANDE_STORE, DEMANDE_PRINT_ACTIONS, type PrintAction } from '@/features/interface/demande/shared'
  import { type IDialog, useDialog } from '@/features/interface/dialog'

  const store = inject(DEMANDE_STORE)!.getStore()!
  const actions = inject(DEMANDE_PRINT_ACTIONS, null)

  const print = async (action: PrintAction) => {
    if (action.mustSave && store.estModifié) {
      await showDialogDemandeModifie(action.jobs.length)
      return
    }
    const jobs = Array.isArray(action.jobs) ? action.jobs : [action.jobs]
    for (const execute of jobs) {
      await execute()
    }
  }

  async function showDialogDemandeModifie(nbJob: number) {
    const text = nbJob > 1 ? 'des documents.' : 'du document.'
    const dialog: IDialog = useDialog()
    await dialog.showDialog({
      isHtml: true,
      message: `
      <div style="text-align:center;">
          La demande a été mise à jour. <br/>
          Merci d'enregistrer votre demande avant de procéder à la génération ${text}
      </div>`,
      type: 'Ok',
    })
  }
</script>
